import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  rows: PropTypes.arrayOf(PropTypes.array).isRequired,
  index: PropTypes.number.isRequired,
  max: PropTypes.number,
};

const ColumnPreview = ({ rows, index, max = 3 }) => {
  return (
    <span className="text-sm">
      {rows
        .map(row => row[index])
        .filter(Boolean)
        .slice(0, max)
        .map((item, idx) => (
          <Fragment key={idx}>
            {item}
            <br />
          </Fragment>
        ))}
    </span>
  );
};

ColumnPreview.propTypes = propTypes;

export default ColumnPreview;
